import { useEffect, useRef } from "react";
import { useAuth } from "@/hooks/use-auth";
import { supabase } from "@/integrations/supabase/client";
import { captureFromUrl, clearReferralCode, getReferralCode } from "@/lib/referral";

/**
 * Captures ?ref=CODE on first paint and, when a user is signed in and has a
 * stored referral code, attempts to attach the referral on the server. The
 * server is idempotent: it only links a referrer if the user's profile was
 * created recently AND no referral row exists for them yet.
 */
export function ReferralCapture() {
  const { user, isLoading } = useAuth();
  const attempted = useRef(false);

  useEffect(() => {
    captureFromUrl();
  }, []);

  useEffect(() => {
    if (isLoading || !user || attempted.current) return;
    const code = getReferralCode();
    if (!code) return;
    attempted.current = true;
    supabase.functions
      .invoke("attach-referral", { body: { code } })
      .then(({ data }) => {
        // Only clear the cookie on a definitive outcome so we don't lose attribution
        // if the call fails transiently.
        if (data && (data.status === "attached" || data.status === "ignored")) {
          clearReferralCode();
        }
      })
      .catch(() => {});
  }, [user, isLoading]);

  return null;
}
